import {
  GET_TYPESREGULATION_FAIL,
  GET_TYPESREGULATION_SUCCESS,
  GET_TYPESREGULATIONS_FAIL,
  GET_TYPESREGULATIONS_SUCCESS,
  ADD_TYPESREGULATION_SUCCESS,
  ADD_TYPESREGULATION_FAIL,
  UPDATE_TYPESREGULATION_SUCCESS,
  UPDATE_TYPESREGULATION_FAIL,
  DELETE_TYPESREGULATION_SUCCESS,
  DELETE_TYPESREGULATION_FAIL,
  SET_STATE_TYPESREGULATION,
} from "./actionTypes";

const INIT_STATE = {
  typesRegulations: [],
  typesRegulation: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const typesRegulations = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TYPESREGULATIONS_SUCCESS:
      return {
        ...state,
        typesRegulations: action.payload.typesRegulations,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_TYPESREGULATION:
      return { ...state, loading: action.payload }

    case GET_TYPESREGULATIONS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_TYPESREGULATION_SUCCESS:
      return {
        ...state,
        typesRegulations: [...state.typesRegulations, action.payload],
      };

    case ADD_TYPESREGULATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_TYPESREGULATION_SUCCESS:
      return {
        ...state,
        typesRegulations: state.typesRegulations.map(typesRegulation =>
          typesRegulation.id.toString() === action.payload.id.toString()
            ? { ...action.payload, typesRegulation }
            : typesRegulation
        ),
      };

    case UPDATE_TYPESREGULATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_TYPESREGULATION_SUCCESS:
      return {
        ...state,
        typesRegulations: state.typesRegulations.filter(
          typesRegulation => typesRegulation.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_TYPESREGULATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_TYPESREGULATION_SUCCESS:
      return {
        ...state,
        typesRegulation: action.payload,
      };

    case GET_TYPESREGULATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default typesRegulations;
